import { UserRoleName } from 'gen/graphql-type'
import {
  User_ExaminationAppointmentPolicy_CreatePrescriptionFragment,
  User_ExaminationAppointmentPolicy_ShowExaminationRoomFragment,
  User_ExaminationAppointmentPolicy_ShowFragment,
  User_ExaminationAppointmentPolicy_ShowSidebarFragment,
  User_ExaminationAppointmentPolicy_ShowVideoCallButtonFragment,
} from './fragment.gen-graphql'
import { authorize, Authorize } from '../authorize'

export const canShow: Authorize<User_ExaminationAppointmentPolicy_ShowFragment> = user => {
  return authorize(user, [
    UserRoleName.Operator,
    UserRoleName.SystemOperator,
    UserRoleName.Pharmacist,
    UserRoleName.Consignor,
    UserRoleName.DoctorManager,
    UserRoleName.Developer,
    UserRoleName.CouponManager,
    UserRoleName.DmhOperator,
    UserRoleName.DmhDoctor,
  ])
}

export const canShowSidebar: Authorize<
  User_ExaminationAppointmentPolicy_ShowSidebarFragment
> = user => {
  return authorize(user, [
    UserRoleName.Operator,
    UserRoleName.SystemOperator,
    UserRoleName.Pharmacist,
    UserRoleName.Consignor,
    UserRoleName.DoctorManager,
    UserRoleName.Developer,
    UserRoleName.CouponManager,
    UserRoleName.DmhOperator,
    UserRoleName.DmhDoctor,
  ])
}

export const canShowExaminationRoom: Authorize<
  User_ExaminationAppointmentPolicy_ShowExaminationRoomFragment
> = user => {
  return authorize(user, [
    UserRoleName.Pharmacist,
    UserRoleName.DmhOperator,
    UserRoleName.DmhDoctor,
  ])
}

export const canCreatePrescription: Authorize<
  User_ExaminationAppointmentPolicy_CreatePrescriptionFragment
> = user => {
  return authorize(user, [UserRoleName.DmhDoctor])
}

export const canShowVideoCallButton: Authorize<
  User_ExaminationAppointmentPolicy_ShowVideoCallButtonFragment
> = user => {
  return authorize(user, [UserRoleName.DmhDoctor])
}
